import React from 'react';
import { HashRouter as Router, Route } from 'react-router-dom';
import { AppProvider } from '../../ApplicationContent/ApplicationContent';
import Footer from '../Footer/Footer';
import Article from '../Article/Article';
import MainPage from '../MainPage/MainPage';
import Header from '../Header/Header';

function App() {
  return (
    <>
    <Router>
        <AppProvider>
          <Header />
          <Route exact path="/" render={() => <MainPage />} />
          <Route exact path="/:id" render={() => <Article />} />
          <Footer />
        </AppProvider>
    </Router>
    </>
  );
}

export default App;
